import { render, staticRenderFns } from "./lab-partners.vue?vue&type=template&id=25b5e6f8"
import script from "./lab-partners.vue?vue&type=script&lang=js"
export * from "./lab-partners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports